// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999 !important;
  animation: fadeIn 0.3s ease-out;
}

.custom-modal-container {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  position: relative;
  animation: slideIn 0.3s ease-out;
}

.custom-modal-container.sm {
  width: 350px;
}

.custom-modal-container.md {
  width: 500px;
}

.custom-modal-container.lg {
  width: 800px;
}

.custom-modal-container.xl {
  width: 1140px;
}

.custom-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-modal-title {
  margin: 0;
  font-weight: 600;
  color: #333;
}

.custom-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.custom-modal-close:hover {
  color: #333;
}

.custom-modal-body {
  padding: 20px;
  overflow-y: auto;
}

.custom-modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Custom Grid for Modal Body */
.custom-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 20px;
}

.custom-row {
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
}

.custom-col-6 {
  width: 50%;
  padding: 10px;
}

.custom-col-12 {
  width: 100%;
  padding: 10px;
}

@media (max-width: 768px) {
  .custom-col-6 {
    width: 100%;
  }
  .custom-modal-container {
    width: 95% !important;
    max-width: 95vw !important;
  }
  .custom-modal-header {
    padding: 12px 16px !important;
  }
  .custom-modal-title {
    font-size: 15px !important;
  }
  .custom-modal-body {
    padding: 14px !important;
  }
  .custom-modal-footer {
    padding: 12px 16px !important;
  }
  .custom-grid-2 {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }
}

@media (max-width: 480px) {
  .custom-modal-header {
    padding: 8px 12px !important;
  }
  .custom-modal-title {
    font-size: 14px !important;
  }
  .custom-modal-body {
    padding: 10px !important;
  }
  .custom-modal-close {
    font-size: 20px !important;
  }
  .custom-modal-footer {
    padding: 8px 12px !important;
    gap: 8px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/commanComponents/CustomModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;AACF","sourcesContent":[".custom-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999999 !important;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.custom-modal-container {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  position: relative;\n  animation: slideIn 0.3s ease-out;\n}\n\n.custom-modal-container.sm {\n  width: 350px;\n}\n\n.custom-modal-container.md {\n  width: 500px;\n}\n\n.custom-modal-container.lg {\n  width: 800px;\n}\n\n.custom-modal-container.xl {\n  width: 1140px;\n}\n\n.custom-modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.custom-modal-title {\n  margin: 0;\n  font-weight: 600;\n  color: #333;\n}\n\n.custom-modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #999;\n  line-height: 1;\n}\n\n.custom-modal-close:hover {\n  color: #333;\n}\n\n.custom-modal-body {\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.custom-modal-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* Custom Grid for Modal Body */\n.custom-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 20px;\n}\n\n.custom-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin: -10px;\n}\n\n.custom-col-6 {\n  width: 50%;\n  padding: 10px;\n}\n\n.custom-col-12 {\n  width: 100%;\n  padding: 10px;\n}\n\n@media (max-width: 768px) {\n  .custom-col-6 {\n    width: 100%;\n  }\n  .custom-modal-container {\n    width: 95% !important;\n    max-width: 95vw !important;\n  }\n  .custom-modal-header {\n    padding: 12px 16px !important;\n  }\n  .custom-modal-title {\n    font-size: 15px !important;\n  }\n  .custom-modal-body {\n    padding: 14px !important;\n  }\n  .custom-modal-footer {\n    padding: 12px 16px !important;\n  }\n  .custom-grid-2 {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .custom-modal-header {\n    padding: 8px 12px !important;\n  }\n  .custom-modal-title {\n    font-size: 14px !important;\n  }\n  .custom-modal-body {\n    padding: 10px !important;\n  }\n  .custom-modal-close {\n    font-size: 20px !important;\n  }\n  .custom-modal-footer {\n    padding: 8px 12px !important;\n    gap: 8px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
